<template>
    <div>
         <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>第三方组织机构</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-col :span="12">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1">钉钉部门</el-menu-item>
                    <el-menu-item index="2">邮箱部门</el-menu-item>
                    <el-menu-item index="3">企业微信部门</el-menu-item>
                </el-menu>
                <el-container>
                    <el-aside style="width:100%;">
                        <el-input style="margin-bottom:12px;margin-top:12px;" size="small" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                        <el-button style="margin-left" type="primary"  size="small" plain @click="getStructure">同步部门架构</el-button>
                        <el-tree class="filter-tree" :data="data" v-loading="loading" :props="defaultProps" node-key="id" :filter-node-method="filterNode" ref="tree">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span style="font-size:14px;height:40px;">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </el-aside>
                </el-container>
            </el-col>
            <el-col :span="8" style="margin-left:60px;">
                
            </el-col>
        </el-row>
    </div>
</template>

<script>
  import {GetTecentMailFrameAndUserTreeList,GetWeChatFrameAndUserTreeList,GetDingFrameAndTreeList,GetupdateMailTreeDepts,GetupdateDingTreeDepts,GetupdateEnterpriseWeChatTreeDepts} from "../../until/ZeusApiSDK/Logic/Frame";
  export default {
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    created() {
        //获取钉钉部门和人员节点信息
        this.getFrameAndUserNode(1);
    },
    methods: {
    getStructure()
    {
         this.$confirm('确定同步架构数据？此操作时间稍长，需耐心等待', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
      
        //同步架构操作                                                               
        if(this.index==1)
        {
            //同步钉钉部门架构
              GetupdateDingTreeDepts().then(res=>{
                this.loading=false;
               if(res.Result==1)
               {
                    this.$message({
                     type: 'success',
                     message: '同步成功!'
                                });
               }
               else
               {
                     this.$message({
                     showClose: true,
                     message: res.Message,
                     type: 'error'            
                                });
               }
            
            });
        }
        else if(this.index==2)
        {
            //同步邮箱部门架构
             GetupdateMailTreeDepts().then(res=>{
                this.loading=false;
               if(res.Result==1)
               {
                     this.$message({
                     type: 'success',
                     message: '同步成功!'
                                });
               }
               else
               {
                     this.$message({
                     showClose: true,
                     message: res.Message,
                     type: 'error'            
                                });
               }
            });

        }
         else if(this.index==3)
        {
            //同步企业微信部门架构
            GetupdateEnterpriseWeChatTreeDepts().then(res=>{
                this.loading=false;
               if(res.Result==1)
               {
                    this.$message({
                     type: 'success',
                     message: '同步成功!'
                                });
               }
               else
               {
                     this.$message({
                     showClose: true,
                     message: res.Message,
                     type: 'error'            
                                });
               }
           });

        }
        
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消同步'
          });          
        });
    },


      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //获取树状结构列表
      getFrameAndUserNode:async function(index){
        if(index==1){
            //获取钉钉部门
            await GetDingFrameAndTreeList().then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
        else if(index==2){
            //获取邮箱部门
            await GetTecentMailFrameAndUserTreeList().then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
        else{
            //获取企业微信部门
            await GetWeChatFrameAndUserTreeList().then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
      },
      //tag页面索引
      handleSelect:function(key, keyPath){
          this.index=key;
          this.loading=true;
          this.getFrameAndUserNode(key);
      },
    },

    data() {
      return {
        wiki:{},
        currentUser:{},
        content:'',
        filterText: '',
        loading:true,
        index:1,//当前部门索引
        frameList:[],
        leaveName:'',
        data:[],
        frameModel:{},//新部门信息
        oldFrameModel:{},//旧部门信息
        activeIndex:'1',//menu页索引
        defaultProps: {
          children: 'children',
          label: 'label',
          disabled:'type'
        }
      };
    }
  };
</script>
<style lang="less" scoped>
.darkTag{
    margin-left: 10px;
    margin-right: 3px;
}
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>